import {useState} from 'react';
import {Link} from '@shopify/hydrogen';
import Headroom from 'react-headroom';
import clsx from 'clsx';
import {useSiteContext} from '../../hooks/useSiteContext';
import LogoIcon from '../icons/Logo';
import UserButtons from './UserButtons.client';
import Navigation, {SideBar} from './Navigation.client';
import AnnouncementBanner from './AnnouncementBanner.client';
import MobileNavigation from './MobileNavigation.client';
import {AnimatePresence} from 'framer-motion';

export default function Nav({
  menuLinks,
  announcementBanner,
  unpinnedHeader,
  reversedHeader,
  countries,
}: any) {
  const {state} = useSiteContext();
  const isNZorAU = state?.geoFenceCode === 'NZ' || state?.geoFenceCode === 'AU';

  const [isPinned, setIsPinned] = useState<boolean>(false);
  const [mobileNavOpen, setMobileNavOpen] = useState<boolean>(false);
  const toggleMobileNav = () => setMobileNavOpen(!mobileNavOpen);
  const flip = !reversedHeader || isPinned || mobileNavOpen;

  const [sideMenuOpen, setSideMenuOpen] = useState<boolean>(false);
  const [activeSideMenuItem, setActiveSideMenuItem] = useState<number>(0);

  return (
    <>
      <Headroom
        style={{zIndex: 80}}
        onPin={() => setIsPinned(true)}
        onUnpin={() => setIsPinned(false)}
        onUnfix={() => setIsPinned(false)}
        disable={unpinnedHeader}
      >
        {announcementBanner && (
          <AnnouncementBanner slides={announcementBanner} />
        )}
        <div
          className={clsx([
            'transition-standard grid grid-cols-2 bg-white px-gutter py-4 xl:grid-cols-3 xl:justify-center xl:px-12 xl:py-7',
            isPinned ? 'bg-opacity-[.95]' : 'bg-opacity-0',
            flip && 'reverse-svg',
          ])}
        >
          {/* LINKS DESKTOP */}
          <Navigation
            sideMenuOpen={sideMenuOpen}
            setSideMenuOpen={setSideMenuOpen}
            activeSideMenuItem={activeSideMenuItem}
            setActiveSideMenuItem={setActiveSideMenuItem}
            menuLinks={menuLinks}
            flip={flip}
          />

          {/* LOGO */}
          <Link
            to="/"
            onClick={() => setMobileNavOpen(false)}
            className="z-30 col-span-1 flex w-full items-center xl:justify-center"
            aria-label="Go to homepage"
          >
            <LogoIcon flip={flip} />
          </Link>

          {/* USER BUTTONS */}
          <div className="relative z-20 col-span-1 flex items-center justify-end gap-x-4">
            {isNZorAU && (
              <div className="mr-[26px] hidden items-center xl:flex">
                <Link
                  aria-label="a link opening the Retailers menu"
                  onClick={() => setSideMenuOpen(false)}
                  className={clsx(
                    'transition-standard border-b-2 border-orange/0 font-bold hover:border-orange',

                    flip || sideMenuOpen ? 'text-dark-gray' : 'text-white',
                  )}
                  to="/stockists"
                >
                  Retailers
                </Link>
              </div>
            )}
            <UserButtons flip={flip} countries={countries} />
            <MobileNavigation
              menuLinks={menuLinks}
              flip={flip}
              toggleMobileNav={toggleMobileNav}
              mobileNavOpen={mobileNavOpen}
              countries={countries}
            />
          </div>
        </div>
      </Headroom>

      {/* Side Menu Modal */}
      <AnimatePresence mode="wait">
        {sideMenuOpen && (
          <div className="hidden xl:block">
            <SideBar
              menuLinks={menuLinks}
              activeSideMenuItem={activeSideMenuItem}
              sideMenuOpen={sideMenuOpen}
              onClick={() => setSideMenuOpen(false)}
            />
          </div>
        )}
      </AnimatePresence>
    </>
  );
}
